import { render, staticRenderFns } from "./FileReferencePickerElement.vue?vue&type=template&id=09b425d9&"
import script from "./FileReferencePickerElement.vue?vue&type=script&lang=js&"
export * from "./FileReferencePickerElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports